<template>
  <v-container class="quote--card ma-0 pa-0 fill-height">
    <v-row class="nowrap" no-gutters>
      <v-col cols="12">
        <v-row v-if="quote" align="center" class="pa-0 nowrap" no-gutters>
          <v-col cols="3" class="text-truncate">
            <span
            class="quote--card_title"
            :class="[quote.status !== 'Rejected' ? 'text--normal': 'wrld_grey--text font-weight-bold']"
            >
              {{ quote.organization.name }}
            </span>
          </v-col>
          <v-col cols="4">
            <span
            class="quote--card_title"
            v-if="quote.price != null && quote.status !== 'Rejected' && quote.status !== 'Withdrawn'"
            :class="[
            quote.status !== 'Accepted' && getIfOneOfQuotesIsAccepted  ? 'wrld_grey--text font-weight-bold' : 'text--normal']"
            >
              {{ [quote.price, quote.currency] | quotePrice }}
            </span>
            <span
            class="quote--card_title"
            v-else-if="!getIfOneOfQuotesIsAccepted"
            :class="[quote.status === 'Rejected' || quote.status === 'Withdrawn' ?'wrld_grey--text font-weight-bold' : 'text--normal']"
            >
              {{ $t('quotes.' + quote.status) }}
            </span>
            <span
            class="quote--card_title wrld_grey--text font-weight-bold"
            v-else
            >
              {{ $t('quotes.' + quote.status) }}
            </span>
          </v-col>
          <v-col class="shrink" cols="5">
            <v-row class="nowrap" align="center" justify="end" no-gutters>
              <v-col v-show="quote.status !== 'Rejected' && quote.status !== 'Accepted' && quote.status !== 'Withdrawn'" cols="5">
                <v-dialog
                  v-model="dialogAcceptConfirm"
                  width="500"
                >
                  <template
                  v-slot:activator="{ on }"
                  >
                    <v-btn
                      class='my-0 px-2'
                      v-if="quote.price != null && !getIfOneOfQuotesIsAccepted"
                      rounded
                      small
                      style="border-radius: 5px; min-width: 0;"
                      color="success"
                      v-on="on"
                    >
                      <span
                        class="font-weight-bold"
                      >
                        {{ $t('buttons.accept') }}
                      </span>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title
                      class="headline grey lighten-2"
                      primary-title
                    >
                      {{ $t('quotes.confirm_accept_title') }}
                    </v-card-title>
                    <v-card-text>
                      <i18n
                        path="quotes.confirm_accept_message"
                        tag="span"
                      >
                        <span>
                          {{ quote.organization.name }}
                        </span>
                        <span>
                          {{ quote.price | humanizeNumber }}
                        </span>
                        <span>
                          {{ quote.currency }}
                        </span>
                      </i18n>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialogAcceptConfirm = false"
                      >
                        {{ $t('buttons.cancel') }}
                      </v-btn>
                      <v-btn
                        color="wrld_red"
                        dark
                        @click="handleAccept"
                      >
                        {{ $t('buttons.confirm') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col v-show="quote.status !== 'Rejected' && quote.status !== 'Accepted' && quote.status !== 'Canceled' && quote.status !== 'Withdrawn'" cols="5">
                <v-dialog
                  v-model="dialogRejectConfirm"
                  width="500"
                  v-if="quote.price != null && !getIfOneOfQuotesIsAccepted"
                >
                  <template
                  v-slot:activator="{ on }"
                  >
                    <v-btn
                      class='my-0 px-2'
                      rounded
                      small
                      style="border-radius: 5px; min-width: 0;"
                      color="error"
                      v-on="on"
                    >
                      <span
                        class="font-weight-bold"
                      >
                        {{ $t('buttons.reject') }}
                      </span>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title
                      class="headline grey lighten-2"
                      primary-title
                    >
                      {{ $t('quotes.confirm_reject_title') }}
                    </v-card-title>
                    <v-card-text>
                      <i18n
                        path="quotes.confirm_reject_message"
                        tag="span"
                      >
                        <span>
                          {{ quote.organization.name }}
                        </span>
                        <span>
                          {{ quote.price | humanizeNumber }}
                        </span>
                        <span>
                          {{ quote.currency }}
                        </span>
                      </i18n>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialogRejectConfirm = false"
                      >
                        {{ $t('buttons.cancel') }}
                      </v-btn>
                      <v-btn
                        color="wrld_red"
                        dark
                        @click="handleReject"
                      >
                        {{ $t('buttons.confirm') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog
                  v-model="dialogCancelConfirm"
                  width="500"
                  v-else-if="!getIfOneOfQuotesIsAccepted"
                >
                  <template
                  v-slot:activator="{ on }"
                  >
                    <v-btn
                      class='my-0 px-2'
                      rounded
                      small
                      style="border-radius: 5px; min-width: 0;"
                      color="error"
                      v-on="on"
                    >
                      <span
                        class="font-weight-bold"
                      >
                        {{ $t('buttons.cancel') }}
                      </span>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title
                      class="headline grey lighten-2"
                      primary-title
                    >
                      {{ $t('quotes.confirm_cancel_title') }}
                    </v-card-title>
                    <v-card-text>
                      <i18n
                        path="quotes.confirm_cancel_message"
                        tag="span"
                      >
                        <span>
                          {{ quote.organization.name }}
                        </span>
                      </i18n>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialogCancelConfirm = false"
                      >
                        {{ $t('buttons.cancel') }}
                      </v-btn>
                      <v-btn
                        color="wrld_red"
                        dark
                         @click="handleCancel"
                      >
                        {{ $t('buttons.confirm') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col
                class="text-right"
              >
                <v-icon size="22" @click="handleExpand">
                  {{ isExpand ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}
                </v-icon>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row v-show="isExpand" no-gutters>
          <v-col cols="12" class="mb-1">
            <v-row class="nowrap fill-height" justify="start" no-gutters>
              <v-col cols="12" no-gutters class="mr-1">
                <v-row no-gutters class="text--truncate">
                  <!-- <div> -->
                   <v-icon
                      size="16"
                      class="mr-1"
                      style="margin-bottom: 3px;"
                      color="wrld_title font-weight-bold"
                    >
                      {{ 'far fa-clock' }}
                    </v-icon>
                    <span
                      class="text-left wrld_grey--text font-weight-bold"
                    >
                      {{ dateOfComputed.text }}
                    </span>
                    <span
                    class="text-left wrld_title--text font-weight-bold ml-1"
                    style="padding-top: 1px;"
                    >{{ dateOfComputed.dateTime | dateToReadable }}</span>
                    <span
                    class="card--dot ml-1 wrld_grey--text"
                    style="padding-top: 1px;"
                    >&#9679;</span>
                    <span
                    class="text-left wrld_title--text font-weight-bold ml-1"
                    style="padding-top: 1px;"
                    >{{ dateOfComputed.dateTime | timeToReadable }}</span>
                  <!-- </div> -->
                </v-row>

                <v-row no-gutters class="text--truncate">
                  <!-- <div> -->
                   <v-icon
                      size="16"
                      class="mr-1"
                      style="margin-bottom: 3px;"
                      color="wrld_title font-weight-bold"
                    >
                      {{ 'fas fa-dolly' }}
                    </v-icon>
                    <span
                      class="text-left wrld_grey--text font-weight-bold"
                    >
                      {{ $t('quotes.transport_type') }}
                    </span>
                    <span
                    class="text-left wrld_title--text font-weight-bold ml-1"
                    style="padding-top: 1px;"
                    >{{ quote.transportType }}</span>
                </v-row>

                <v-row v-if="quote.incoterms" no-gutters class="text--truncate">
                  <!-- <div> -->
                   <v-icon
                      size="16"
                      class="mr-1"
                      style="margin-bottom: 3px;"
                      color="wrld_title font-weight-bold"
                    >
                      {{ 'fas fa-poll-h' }}
                    </v-icon>
                    <span
                      class="text-left wrld_grey--text font-weight-bold"
                    >
                      {{ $t('quotes.incoterms') }}
                    </span>
                    <span
                    class="text-left wrld_title--text font-weight-bold ml-1"
                    style="padding-top: 1px;"
                    >{{ quote.incoterms }}</span>
                </v-row>

                <v-row v-if="quote.transportType === 'Air' && quote.originPort || quote.transportType === 'Ocean' && quote.originPort" no-gutters class="text--truncate">
                  <!-- <div> -->
                   <v-icon
                      size="16"
                      class="mr-1"
                      style="margin-bottom: 3px;"
                      color="wrld_title font-weight-bold"
                    >
                      {{ 'fas fa-map-pin' }}
                    </v-icon>
                    <span
                      class="text-left wrld_grey--text font-weight-bold"
                    >
                      {{ $t('quotes.origin_port') }}
                    </span>
                    <span
                    class="text-left wrld_title--text font-weight-bold ml-1"
                    style="padding-top: 1px;"
                    >{{ quote.originPort }}</span>
                </v-row>

                <v-row v-if="quote.transportType === 'Air' && quote.destinationPort || quote.transportType === 'Ocean' && quote.destinationPort" no-gutters class="text--truncate">
                  <!-- <div> -->
                   <v-icon
                      size="16"
                      class="mr-1"
                      style="margin-bottom: 3px;"
                      color="wrld_title font-weight-bold"
                    >
                      {{ 'fas fa-flag' }}
                    </v-icon>
                    <span
                      class="text-left wrld_grey--text font-weight-bold"
                    >
                      {{ $t('quotes.destination_port') }}
                    </span>
                    <span
                    class="text-left wrld_title--text font-weight-bold ml-1"
                    style="padding-top: 1px;"
                    >{{ quote.destinationPort }}</span>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="2" no-gutters class="mr-1">
                <v-row
                no-gutters
                class="fill-height text-left wrld_grey--text font-weight-bold">
                  <v-icon
                    size="16"
                    color="wrld_title"
                    class="mr-1"
                  >
                    {{ 'far fa-clipboard' }}
                  </v-icon>
                    {{ $t('quotes.notes') }}
                </v-row>
              </v-col>
              <v-col cols="12" >
                <v-card class="quote--card_notes" flat>
                  <v-card-text>{{ quote.requestComment }}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="6"
            class="mt-1"
          >
          <AttachmentsUpload
            :title="$t('attachments.request_attachments')"
            resource="quote"
            :resourceID="quote.id"
            :activatorText=" $t('attachments.upload_attachments')"
          />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AttachmentsUpload from '@/components/wrld/generic/attachments/AttachmentsUpload'
export default {
  name: 'QuoteItemCardBig',
  components: {
    AttachmentsUpload
  },
  props: {
    quote: { value: Object | Boolean, default: false },
    isExpand: { type: Boolean, defaul: false }
  },
  data() {
    return {
      dialogAcceptConfirm: false,
      dialogCancelConfirm: false,
      dialogRejectConfirm: false
    }
  },
  methods: {
    ...mapActions({
      updateSecondResourceOverviewList: 'updateSecondResourceOverviewList',
      setListAttachments: 'attachments/setListAttachments',
      downloadRequest: 'attachments/downloadRequest',
    }),
    handleExpand () {
      this.setListAttachments({
        resource: 'quote',
        resourceID: this.quote.quoteID
      })
      this.$emit('expand', this.quote.quoteID)
    },
    handleAccept () {
      this.$emit('accept', this.quote.quoteID)
    },
    handleReject () {
      this.$emit('reject', this.quote.quoteID)
    },
    handleCancel () {
      this.$emit('cancel', this.quote.quoteID)
    },
    handleDownloadAttachment({ s3Key, filename }) {
      this.downloadRequest({ s3Key, filename })
    }
  },
  computed: {
    ...mapGetters({
      getIfOneOfQuotesIsAccepted: 'getIfOneOfQuotesIsAccepted',
      getListAttachments: 'attachments/getListAttachments',
      getIsFetching: 'attachments/getIsFetching',

  }),
    dateOfComputed () {
      switch (this.quote.status) {
        case 'Requested':
          return {
            text: this.$t('quotes.date_of_request'),
            date: this.quote.createdAt
          }
        case 'Quoted':
          return {
              text: this.$t('quotes.date_of_pricing'),
              dateTime: this.quote.quotedAt
            }
        case 'Accepted':
          return {
              text: this.$t('quotes.date_of_acceptance'),
              dateTime: this.quote.acceptedAt
            }
        case 'Rejected':
          return {
              text: this.$t('quotes.date_of_rejection'),
              dateTime: this.quote.rejectedAt
            }
        case 'Canceled':
          return {
              text: this.$t('quotes.date_of_cancellation'),
              dateTime: this.quote.canceledAt
            }
        case 'Withdrawn':
          return {
              text: this.$t('quotes.date_of_withdrawal'),
              dateTime: this.quote.withdrawnAt
            }
        default:
          return {
            text: this.$t('quotes.date_of_request'),
            dateTime: this.quote.createdAt
          }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .quote--card {
    .quote--card_title {
      font-size: 14px;
      color:#484848;
    }
    .card--wrapper--dot {
      position: relative;
      display: inline-block;
      width: 11px;
      height: 100%;
      .card--dot {
        color: #767676;
        position: absolute;
        display: inline-block;
        font-size: 11px;
        margin-left: 2px;
        margin-right: 2px;
        top: 10%;
      }
    }
    .text--normal {
      font-size: 14px;
      color: #484848;
      font-weight: 500;
    }
    .quote--card_notes {
      max-width: 750px;
      border: 1px solid #dedede;
      border-radius: 5px;
    }
  }
  @media only screen and (max-width: 1440px) {
    .quote--card {
      .quote--card_notes {
        max-width: 450px;
      }
    }
  }
</style>
